import { mapActions } from 'vuex';
import Events from '_utils/events';
import ProductService from '_services/rest/modules/product';

export default {
  data() {
    return {
      selectedObject: null,
    };
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert']),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      if (!this.selectedObject) return;

      this.setToggle({ type: 'progress', bool: true });

      ProductService.deleteProduct(this.selectedObject)
        .then(response => {
          this.close();

          if (this.redirectPath) {
            this.$router.push(this.redirectPath);
          }

          if (this.emitEvent) {
            Events.$emit(this.emitEvent, response || true);
          }

          this.activeAlert({ message: this.successMessage, theme: 'success' });
        })
        .catch(error => {
          this.activeAlert({ message: error.message, theme: 'danger' });
        })
        .finally(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
  },
};
